import axios from 'axios'

const BASE_URL = 'https://mediaapi.hebei.com.cn/api/2026tsddz50znhd/api'
const request = axios.create({
  timeout: 30000
})
function stringifyData(data) {
  return JSON.stringify(data)
}

function postForm(url, params) {
  var data = new URLSearchParams()
  Object.keys(params).forEach(function(key) {
    data.append(key, typeof params[key] === 'string' ? params[key] : stringifyData(params[key]))
  })
  return request.post(url, data)
}

export function getFwl() {
  return request.get(BASE_URL + '/fwl.php')
}
//内容接口
export function getList() {
  return request.get(BASE_URL + '/list.php')
}
export function getDmList() {
  return request.get(BASE_URL + '/bulletchat.php')
}
export function getPoster() {
  return request.get(BASE_URL + '/poster.php')
}
